import { useLocation } from "react-router-dom"
import { FaEdit } from "react-icons/fa";
import BasicDataTable from "../../../../../Component/BasicComponents/BasicDataTable";
import { useOutletDCRSummary, useOutletSgpiOutSummary } from "../../hooks/useCustomer";
import { useState } from "react";


const TableColumns = () => [
  {
    name: "Moye",
    selector: (row: { Moye: string }) => row.Moye||"-",
  },
  {
    name: "Territory Name",
    selector: (row: { TerritoryName: string }) => row.TerritoryName||"-",
  },
  {
    name: "Outlet Org Data",
    selector: (row: { OutletOrgData: string }) => row.OutletOrgData||"-",
  },
  {
    name: "SGPI Type",
    selector: (row: { SgpiType: string }) => row.SgpiType||"-",
  },
  {
    name: "Qty",
    selector: (row: { Qty: string }) => row.Qty||"-",
    wrap: true,
  },
   {
    name: "Last Create",
    selector: (row: { LastCreate: string }) => row.LastCreate||"-",
    wrap:true
  },
];

const SgpiOutSummaryTable=({OutletOrgId}:any)=>{

    console.log('sgpiOut mai',OutletOrgId)
     const [pageState, setPageState] = useState({
     page: 1,
   });
   const [limitState, setLimitState] = useState({
     limit: 10,
   });
   const [search,setSearch]=useState({
     searchValue:null
   })


    const{data:SgpiOutData}=useOutletSgpiOutSummary({
        enabled:!!OutletOrgId,
        id:OutletOrgId,
        params:{
            page:pageState.page,
            limit:limitState.limit,
            search:search.searchValue
        }
    })


const formateTableData = () =>
  (SgpiOutData?.data?.SgpiOutSummaryData || []).map((key: any) => ({
    Moye: key.Moye,
    TerritoryName: key.TerritoryName||"",
    OutletOrgData: key.OutletOrgdataId||"",
    SgpiType: key.SgpiType,
    Qty: key.Qty,
    LastCreate: key.Lastcreate,
  }));




const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
 
      };
  });
      setLimitState((prevState: any) => {
        return {
          ...prevState,
          limit: limit,
        };
      });
    
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  }

   const handleSearch = (searchValue: any) => {
    setSearch((prevState: any) => {
      return {
        ...prevState,
        searchValue,
      };
    });
  }


return(
    <div>
<BasicDataTable
paginationTotalRows={SgpiOutData?.data?.Pagination.TotalSgpiOutSummary}
columns={TableColumns()}
data={formateTableData()||[]}
Title="SGPI Out Summary"
onChangePage={(pageNo: number) => {
             handlePagination(pageNo);
           }}
          onChangeRowsPerPage={(newPerPage: any, page: any) => {
           handleonChangeRowsPerPage(newPerPage, page);
         }}
            handleSearch={(val: any) => {
          handleSearch(val);
        }}
/>
    </div>
)
}
export default SgpiOutSummaryTable